import { actionAddException } from 'react-redux-app/lib/modules/exception/actions';

import { getCurrentSiteId } from '../../site/selectors';

import {
  ACTION_LOAD_FAVICON__FAIL,
  ACTION_LOAD_FAVICON__REQUEST,
  ACTION_LOAD_FAVICON__SUCCESS,
} from '../actionTypes';


const actionLoadFaviconSuccess = favicon => ({
  type: ACTION_LOAD_FAVICON__SUCCESS,
  payload: { favicon },
});

const actionLoadFaviconFail = error => ({
  type: ACTION_LOAD_FAVICON__FAIL,
  payload: { error },
});

export const actionLoadFaviconRequest = () => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_LOAD_FAVICON__REQUEST,
    });

    return apiClientHelper.get(
      `/rest/webmaster/favicon/${getCurrentSiteId(getState())}`
    ).then(
      favicon => {
        dispatch(actionLoadFaviconSuccess(favicon));
      },
      error => {
        dispatch(actionLoadFaviconFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);
